export default __webpack_public_path__ + "static/media/13-DTG-Fair.925d7c8f.JPG";